import SPfetch from "@services/SPFetch.class";

export const initialEmailErrorMsg = "Please enter a valid email address.";

export const emailTakenErrorMsg = `That email already exists. <a href="/sign-in">Sign in now</a>`;

export const initialEmailSuggestion = {
  shouldShow: false,
  suggestion: "",
};

export const dbEmailExists = async (email: string) => {
  try {
    const reqData = {
      data: {
        type: "users",
        attributes: {
          email,
        },
      },
    };

    const res = await SPfetch.post(
      `${process.env.GATSBY_WS_URL}/api/checkEmail`,
      reqData
    );
    const data = await res.json();
    const errors = data?.errors;
    const error = errors.find((err: any) => err.id.includes("email#taken"));

    if (error) {
      return true;
    }

    return false;
  } catch (error) {
    return false;
  }
};
